import { Col, Row } from 'react-bootstrap'

import { FunnelIcon } from '@heroicons/react/24/outline'

import { Icons } from '../../../../../../assets/icons/icons'

const Header = ({
    dmode,
    depName,
    fieldCount,
    simulationObj,
    header,
    isTable,
    t,
    toggleFunc,
    clusterName,
    fieldArrayName,
}) => {
    // console.log('simObj', simulationObj);
    
    return (
        <div>
            <Row className="align-items-center justify-content-end">
                <Col xs="auto">
                    <button
                        className="head-close-button"
                        onClick={() => toggleFunc()}
                    >
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            fill="none"
                            viewBox="0 0 24 24"
                            stroke-width="1.3"
                            stroke="#4F4F4F"
                            class="size-4"
                            width="25"
                            height="25"
                        >
                            <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                d="M6 18 18 6M6 6l12 12"
                            />
                        </svg>
                    </button>
                </Col>
            </Row>
            <Row className="align-items-center justify-content-between modal-head-row">
                <Col xs="auto">
                    <div
                        style={{
                            display: 'flex',
                            justifyContent: 'center',
                        }}
                    >
                        {isTable ? (
                            <div style={{ marginTop: 3 }}>
                                {Icons.Planogram({
                                    size: 24,
                                    color: `${dmode ? '#FFF' : 'none'}`,
                                })}
                            </div>
                        ) : (
                            <FunnelIcon
                                style={{
                                    height: 28,
                                    width: 28,
                                    color: dmode && 'white',
                                }}
                            />
                        )}
                        <span className={`head-line ${dmode && 'head-dark'}`}>
                            {t(header)}
                        </span>
                    </div>
                </Col>
            </Row>
            <Row className="align-items-center justify-content-between modal-head-row">
                <Col xs="auto">
                    <span style={{ color : dmode ? '#fff' : '#000' }}>
                        <strong>{t('departmentName')}</strong>: {depName}{' '}
                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                        <strong>{t('FIELD_COUNT')}</strong>: {simulationObj.fieldList.length}
                        {clusterName && (
                            <>
                                {' '}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                <strong>{t('Cluster')}</strong>: {clusterName}
                            </>
                        )}
                        {fieldArrayName && (
                            <>
                                {' '}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                <strong>{t('FIELD_ARRAY')}</strong>: {fieldArrayName}
                            </>
                        )}
                    </span>
                </Col>
            </Row>
        </div>
    )
}

export default Header
